import { Result } from "antd";

const NotFoundPage = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, this page does not exist."
    />
  );
};

export default NotFoundPage;
